import { SearchEngineDataService } from 'src/app/_services/search-engine-data.service';
import { AuthService } from './../../../_services/auth.service';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Optional } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-benefit-post',
  templateUrl: './benefit-post.component.html',
  styleUrls: ['./benefit-post.component.css']
})
export class BenefitPostComponent implements OnInit {
  post$: Observable<string> | undefined;
  slug =""
  constructor(private route: ActivatedRoute, public authService:AuthService,@Optional() private searchEngineMetaData:SearchEngineDataService) {}

  ngOnInit() {
  // use an observable to construct the path to the Markdown file:

      this.post$ = this.route.params.pipe(
        map((params) =>{
           this.slug=params['id']
           return `/assets/blog/benefits/${params['id']}.md`
        }
      ))
        this.initMetaData()
    }
    initMetaData(): void {
      if (this.searchEngineMetaData) {
        this.searchEngineMetaData.updateMetadata({
          title: this.slug,
          description: this.slug,
          author:"Boldungu Team"
        });
      }
    }
}
